export default "__VITE_ASSET__Bqd6lsJQ__"